import {Injectable, PLATFORM_ID, inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  get loading(): boolean {
    return this._loading;
  }

  private _loading = false;
  private pendingCount = 0;
  private showTimer?: ReturnType<typeof setTimeout>;
  private forceStopTimer?: ReturnType<typeof setTimeout>;
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  private readonly startDelay = 150;
  private readonly maxVisibleDuration = 3000;

  constructor() {
  }


  startLoader() {
    if (!this.isBrowser) {
      return;
    }

    this.pendingCount++;

    if (this.pendingCount === 1) {
      this.showTimer = setTimeout(() => {
        if (this.pendingCount > 0) {
          this._loading = true;
        }
      }, this.startDelay);

      // anyway stop loader
      this.forceStopTimer = setTimeout(() => {
        this.reset();
      }, this.startDelay + this.maxVisibleDuration);
    }
  }


  stopLoader() {
    if (!this.isBrowser || this.pendingCount === 0) {
      return;
    }

    this.pendingCount--;

    if (this.pendingCount === 0) {
      this._loading = false;
      clearTimeout(this.showTimer);
      clearTimeout(this.forceStopTimer);
    }
  }


  private reset() {
    this.pendingCount = 0;
    this._loading = false;
    clearTimeout(this.showTimer);
    clearTimeout(this.forceStopTimer);
  }
}
